import { isEqual, map } from 'lodash'
//import store from 'store'
import dayjs from 'dayjs'
import 'dayjs/locale/de'
import { useCraftsmanTaskStore } from '@/stores/modules/craftsmanTask.ts'
import { useTaskStore } from '@/stores/modules/task.ts'
import { useCisStore } from '@/stores/modules/cis.ts'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import he from 'he'

dayjs.locale('de')
dayjs.extend(customParseFormat)

const storeMap = {
	craftsman_tasks: useCraftsmanTaskStore,
	tasks: useTaskStore,
	cis: useCisStore,
}

const Funcs = {
	getDateObject: (isoDate) => {
		let dateMoment = parseIsoDate(isoDate)
		if (typeof dateMoment === 'undefined') {
			return {
				formatted: '',
				raw: '',
				ts: '',
			}
		}
		return {
			formatted: dateMoment.format('DD.MM.YYYY'),
			raw: dateMoment.format('YYYY-MM-DD'),
			ts: dateMoment.unix(),
		}
	},
	getTime: (isoDate) => {
		let dateMoment = parseIsoDate(isoDate)
		if (typeof dateMoment === 'undefined') {
			return ''
		}

		return dateMoment.format('HH:mm')
	},
	async updateLinks({ module, moduleId, links, initLinks = {} }) {
		if (links.buildings !== undefined && links.units !== undefined) {
			links.buildings = undefined
		}
		await Promise.allSettled(
			map(links, async (link, key) => {
				if (!isEqual(links[key], initLinks[key])) {
					if (initLinks[key]) {
						storeMap[module]
							? storeMap[module]().detach({
									id: moduleId,
									target: key,
									targetId: initLinks[key].id,
								})
							: undefined
					}
					if (links[key]) {
						storeMap[module]
							? storeMap[module]().attach({
									id: moduleId,
									target: key,
									targetId: links[key].id,
								})
							: undefined
					}
				}
			})
		)
	},
	updateProperties(source, destination, propertyName = undefined) {
		let updated = []
		if (source && typeof source === 'object') {
			for (const key in source) {
				if (
					Object.prototype.hasOwnProperty.call(destination, key) &&
					source[key] &&
					typeof source[key] !== 'boolean'
				) {
					destination[key] = source[key]
					updated.push(key)
				}
			}
		}
		return updated
	},
	maskTimeInput(time = '', short = true) {
		let HHmmss = new RegExp('^\\d{2}:\\d{2}:\\d{2}$')
		let HHmm = new RegExp('^\\d{2}:\\d{2}$')

		if (!(HHmmss.test(time) || HHmm.test(time))) return undefined
		const format = HHmm.test(time) ? 'HHmm' : 'HHmmss'
		const trimedTime = time.split(':').join('')
		return dayjs(trimedTime, format).format(short ? 'HH:mm' : 'HH:mm:ss')
	},
	buildFormData: (data = {}, options = {}) => {
		let formData = new FormData()
		for (let key in data) {
			let hasOptions = options[key]
			if (!Object.prototype.hasOwnProperty.call(data, key)) {
				continue
			}
			if (key.endsWith('[]') && Array.isArray(data[key])) {
				data[key].forEach((subItem) => {
					formData.append(
						key,
						hasOptions?.stringify ? JSON.stringify(subItem) : subItem
					)
				})
			} else if (typeof data[key] !== 'undefined') {
				formData.append(key, data[key])
			}
		}

		return formData
	},
	isValidDate: (d) => d instanceof Date && !isNaN(d),
	fixUmlauts: (value) => {
		return he.encode(value, {
			allowUnsafeSymbols: true,
		})
	},
}

function parseIsoDate(date) {
	if (typeof date === 'undefined' || date === '' || date === null) {
		return undefined
	}

	return dayjs(date)
}

export default Funcs
